module.exports = __webpack_public_path__ + "img/shooting04.47691009.jpeg";